import { Box, HStack, Text } from '@chakra-ui/react';
import React, { FC } from 'react';
import { toOptionalFixed } from '@app/helpers/format';
import { usePairTvl } from '@app/hooks/pair/usePairTvl';
import { PoolTokensCell } from '@app/screens/pools/components/PoolTokensCell';
import { Pair, PairDayData } from '@app/types/pool';
import { usePairAprV2 } from '@app/hooks/pools/usePairAprV2';
import { LabeledValue } from '@app/screens/liquidity/LiquidityWizard/components/SelectTokensStep/components/LabeledValue';
import { formatUSD } from '@app/helpers/formatUSD';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';

interface Props {
  item: Pair;
  ethPrice: string | null | undefined;
  dayData: PairDayData[] | undefined;
}

export const PoolDetailsV2: FC<Props> = ({ item, ethPrice, dayData }) => {
  const {
    flow,
    mode,
    currencyB,
    currencyA,
    actions: { setMode, setStrategy, setProvider, setFlow }
  } = useLiquidityWizardState();
  const {
    token0,
    token1,
    reserve0,
    reserve1,
    id,
    token0Price,
    token1Price,
    isMain,
    isNotVerified
  } = item;

  const tvl = usePairTvl(ethPrice, item);

  const { currentApr } = usePairAprV2({
    token0,
    token1,
    reserve0,
    reserve1,
    pairAddress: id,
    token0Price,
    token1Price,
    dayData
  });

  const isSelected =
    ((currencyA?.wrapped.address.toLowerCase() === token0.id.toLowerCase() &&
      currencyB?.wrapped.address.toLowerCase() === token1.id.toLowerCase()) ||
      (currencyA?.wrapped.address.toLowerCase() === token1.id.toLowerCase() &&
        currencyB?.wrapped.address.toLowerCase() ===
          token0.id.toLowerCase())) &&
    mode === 'manual' &&
    flow === 'v2';

  return (
    <Box
      sx={{
        backgroundColor: 'gray.16',
        p: '24px',
        width: '100%',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'filter 0.3s ease',
        border: '1px solid',
        borderColor: isSelected ? 'orange' : 'transparent'
      }}
      _hover={{
        filter: 'brightness(120%)'
      }}
      onClick={() => {
        setMode('manual');
        setFlow('v2');
        setProvider(null);
        setStrategy(null);
      }}
    >
      <PoolTokensCell
        token0={token0}
        token1={token1}
        isMain={isMain}
        isNotVerified={isNotVerified}
        version={2}
      />

      <HStack gap="24px" width="100%" mt={6} alignItems="flex-start">
        <LabeledValue label="TVL" value={formatUSD.format(+tvl)} />
        {/*<LabeledValue label="VOLUME" value="volume???" />*/}
        <LabeledValue
          label="APR"
          value={
            <HStack alignItems="center" gap={1}>
              <Text color="gray.4" mr={2}>
                {currentApr ? `${toOptionalFixed(currentApr, 2)}%` : '-'}
              </Text>
            </HStack>
          }
        />
      </HStack>
    </Box>
  );
};
